import SonsOfThunderCharacters from './Characters/SonsOfThunder';

export default {
  SonsOfThunderCharacters
};
